import type { MarketType } from '@ps/isp-web-services-types';

export const oddsBoostMarketTypeCodes = [
  'ODDS_BOOST',
  'POWER_PRICES',
  'DAILY_POWER_PRICES',
  'POWER_PRICE',
  'POWER_PRICES_PSSFR',
  'POWER_PRICES_PSSCOM',
  'POWER_PRICES_PSSBF'
] as const satisfies readonly MarketType[];

export type OddsBoostMarket = (typeof oddsBoostMarketTypeCodes)[number];

export const isOddsBoostMarket = (marketType?: MarketType): marketType is OddsBoostMarket =>
  oddsBoostMarketTypeCodes.includes(marketType as OddsBoostMarket);
